import React, { useEffect, useState } from 'react';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';

const Chat = (props) => {
  const [value, setValue] = useState(true);

  useEffect(() => {
    props.setPageParams({
      alias: 'test',
      title: '測試頁'
    });
  }, []);

  useEffect(() => {
    console.log(value);
  }, [value]);

  return (
    <>
      Chat Page
    </>
  );
};

export default Chat;
